module.exports = __webpack_public_path__ + "img/qa-testing.e3a17f53.svg";